import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type EmMachine } from "@packsize/schemas/machines";

import { getEmMachine } from "@/api/machines/em-api-v2";

import { EM_MACHINES_QUERY_KEY } from "./query-keys";

export const useEmMachine = (
	machineId: string | null | undefined,
	enabled: boolean = true,
	refetchInterval: number | false = false,
): UseQueryResult<EmMachine | null, Error> => {
	return useQuery({
		queryKey: [...EM_MACHINES_QUERY_KEY, { machineId }],
		queryFn: () => getEmMachine(machineId || ""),
		enabled: enabled && Boolean(machineId),
		refetchInterval,
	});
};
